import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { contactInfo } from '../data/mock';

// Logo Pam Immobilier
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_realty-preview-2/artifacts/t4dikgev_image.png';

const Footer = () => {
  return (
    <footer className="bg-[#8B2942] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Pam Immobilier" 
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-white/80 leading-relaxed">
              Votre partenaire de confiance pour l'achat et la vente de biens immobiliers dans la région.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors duration-200">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-white/80 hover:text-white transition-colors duration-200">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/a-vendre" className="text-white/80 hover:text-white transition-colors duration-200">
                  Biens à vendre
                </Link>
              </li>
              <li>
                <Link to="/vendus" className="text-white/80 hover:text-white transition-colors duration-200">
                  Biens vendus
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/80">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-white transition-colors duration-200">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors duration-200">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/20 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Pam Immobilier. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
